var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"loading-text":_vm.loadingText,"headers":_vm.headers,"items":_vm.summary.availabilities,"items-per-page":_vm.itemsPerPage,"hide-default-footer":"","multi-sort":"","sort-by":['date']},scopedSlots:_vm._u([{key:"item.book",fn:function({ item }){return [_c('router-link',{attrs:{"to":{ name: 'queue-management',
         query: {
          fupId: item.id
          }
        }}},[_vm._v("Queue Link")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }